import React from "react";
import "./HairSalon.css";
const HairSalonPara = () => {
  return (
    <div className="hairSalonParaContainer">
      <p>
        Step into the salon for best-in-class haircuts, hair colour, hair spa
        and hair smoothening treatments, done by trained hair stylists.
        Great hair days truly begin at Scent Hair Salon
      </p>
    </div>
  );
};

export default HairSalonPara;
